import PropTypes from 'prop-types';
import React from 'react';

import IconBounds from '../IconBounds';
import { Clear } from '../shapes';


const ClearSvg = (props) => (
  <g>
    <IconBounds />
    <Clear {...props} />
  </g>
);

ClearSvg.propTypes = {
  fill: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.number,
};

ClearSvg.defaultProps = {
  fill: '#000',
  stroke: '#000',
  strokeWidth: 1,
};


export default ClearSvg;
